import CustomizableVariables from "./CustomizableVariables";
import AutoPopulatedVariables from "./AutoPopulatedVariables";
import PartnershipVariables from "./PartnershipVariables";
import RbpSection from "./RbpSection";
import "./VariablesTab.scss";

/**
 * Variables tab — customizable, auto-populated, partnership, and RBP regions.
 *
 * @param {object} props
 * @returns {import('react').JSX.Element}
 */
const VariablesTab = ({
    form,
    autoPopulated,
    isPartnershipPlan,
    isPcpCopaySelected,
    isRbpYes,
    networkNames,
    validationErrors,
    onFieldChange,
    onSelectOption,
    onNetworkSelect,
    onNetworkOtherChange,
    onPcpCopaySelect,
    onPcpCopayOtherChange,
    onReferralSelect,
    onReferralCustomChange,
    onRbpSelect,
    onRbpLanguageSelect,
    onRbpLanguageTextChange,
}) => (
    <div id="panel-variables" role="tabpanel" aria-labelledby="tab-variables">
        <p className="plan-notification-tab-helper">
            You must enter all input fields below to activate the notifications tab
        </p>

        <div className="plan-notification-variables-layout">
            <div className="plan-notification-variables-layout__row">
                <CustomizableVariables
                    form={form}
                    isPartnershipPlan={isPartnershipPlan}
                    networkNames={networkNames}
                    validationErrors={validationErrors}
                    onFieldChange={onFieldChange}
                    onSelectOption={onSelectOption}
                    onNetworkSelect={onNetworkSelect}
                    onNetworkOtherChange={onNetworkOtherChange}
                />
                <AutoPopulatedVariables autoPopulated={autoPopulated} />
            </div>

            <PartnershipVariables
                form={form}
                isPartnershipPlan={isPartnershipPlan}
                isPcpCopaySelected={isPcpCopaySelected}
                validationErrors={validationErrors}
                onPcpCopaySelect={onPcpCopaySelect}
                onPcpCopayOtherChange={onPcpCopayOtherChange}
                onReferralSelect={onReferralSelect}
                onReferralCustomChange={onReferralCustomChange}
            />

            <RbpSection
                form={form}
                isRbpYes={isRbpYes}
                validationErrors={validationErrors}
                onRbpSelect={onRbpSelect}
                onRbpLanguageSelect={onRbpLanguageSelect}
                onRbpLanguageTextChange={onRbpLanguageTextChange}
            />
        </div>
    </div>
);

export default VariablesTab;
